<template>
  <div class="indentification-protocol">
    <div class="protocol-content">
      <div class="title">{{i18n.page_content_digitalUsageProtocol}}</div>
      <div class="text-content">
        <div class="sub-title">{{i18n.page_content_statement}}</div>
        <div class="detail">
          1.您应当认真阅读并遵守《数字证书使用协议》（以下简称“本协议”），本协议具有合同效力，当您勾选确认或点击确认并完成注册后即成立生效。<br /><br />
          2.您务必审慎阅读、充分理解各条款内容，如您对本协议有任何疑问或对任何条款不能准确理解的，请不要进行后续操作。<br /><br />
          3.您承诺接受并遵守本协议的约定，届时您不可以未阅读本协议内容或未获得杭州尚尚签网络科技有限公司对您问询的解答等理由，主张本协议无效，或要求撤销本协议。<br /><br />
          4.本数字证书服务协议更新日期为 2019年 x月 xx日，将于 2019年 x月x日正式生效。
        </div>
        <div class="sub-title">一 数字证书服务简介</div>
        <div class="detail">
          1.杭州尚尚签网络科技有限公司与工信部许可的电子认证服务机构合作，为通过实名认证后的互联网个人或企业申请数字证书。<br /><br />
          2.您通过杭州尚尚签网络科技有限公司的上上签平台完成实名认证并使用数字证书获得电子签名服务，成为上上签电子签名体系不可分割的部分。<br /><br />
          3.本协议中的“证书”指个人数字证书或企业数字证书。
        </div>
        <div class="sub-title">二 名词解释</div>
        <div class="detail">
          1.订户：指从委托上上签从权威第三方电子认证服务机构获得证书的个人、组织机构。<br /><br />
          2.数字证书：是指一段信息，它至少包含了一个名字，标识特定的CA或标识特定的订户，包含了订户的公钥、证书有效期、证书序列号，及CA数字签名。<br /><br />
          3.证书私钥：数字证书包含证书本身和一个密钥对，密钥对的一部分是公钥，另一部分称为私钥。公钥公之于众，谁都可以使用。私钥只有自己知道，一般信息都是由公钥进行加密，相对应的私钥进行解。
        </div>
        <div class="sub-title">三 订户的权利和义务</div>
        <div class="detail">
          1.您应按照上上签规定的证书申请流程向上上签平台提供有关资料，并保证所填写的注册
          信息和所提供的资料的真实性、准确性和完整性，否则上上签平台或上上签有权拒绝您的申请请求。在这些信息、资料发生改变时及时通知上上签。如因您故意或过失提供的资
          料不真实、不完整、不准确或资料改变后未及时通知上上签，造成的损失由订户自己承担。<br /><br />
          2.您的证书信息在证书有效期限内变更的，应当及时书面告知上上签平台和上上签，并终止使用该证书。<br /><br />
          3.若您为企业用户，您企业分立、合并、解散、注销、宣告破产或倒闭，或被撤销营业执照等主体资格终止的，应于上述情况发生时的
          5个工作日内通过书面形式告知上上签申请撤销数字证书，并终止使用该证书，否则，因未尽该通知义务给上上签造成损失的，由您全部赔偿。<br /><br />
          4.您同意上上签平台向有关部门和个人核实您的信息。上上签平台应合法地收集、处理、传递及应用您的资料，按照国家有关规定及本协议的约定予以保密。<br /><br />
          5.您对证书享有独立的使用权，您应当合法使用数字证书签署电子文件，并对使用数字
          证书的行为负责。您使用证书产生的权利，由您享有；您使用证书产生的义务、责任，由您承担。<br /><br />
          6.您应当对您所专有并控制的数字证书及上上签账户进行妥善保管，当您收到您在上上签账户设置的通知方式（手机和邮箱）收到签署验证码时，应确保签署请求由本人发起，且对验证码承担保密义务。如您使用的数字证书私钥和密码泄漏、丢失，或者您不希望继续使用数字证书，或者您的主体不存在，您应当立即向上上签申请废止该数字证书。因您原因致使证书私钥泄露、损毁或者丢失的，损失由您承担。<br /><br />
          7.您损害权威第三方电子认证服务机构利益的，须向电子认证服务机构赔偿全部损失。这些情形包括但不限于：<br /><br />
          ①您在申请数字证书时没有提供真实、完整、准确信息，或在这些信息变更时未及时通知上上签；<br /><br />
          ②您知道自己的私钥已经失密或者可能已经失密而未及时告知有关各方、并终止使用；<br /><br />
          ③您有其他过错或未履行本协议的相关约定。<br /><br />
          8.权威第三方电子认证服务机构有权因安全风险因素要求上上签更换您的数字证书。<br /><br />
          9.您申请代码签名证书后，一旦发现如下情况之一时，应当立即向上上签申请吊销此证书：<br /><br />
          ①证据表明，此代码签名证书被用于签署可疑代码，包括但不限于病毒，木马，或者其他不恰当的程序。<br /><br />
          ②证书中内容不再正确或不再准确。<br /><br />
          ③此证书私钥信息已被泄露、丢失，或者其他相关部分已被错误使用。<br /><br />
          10.证书一旦被吊销，订户将不能再使用该证书。<br /><br />
          11.如果权威第三方电子认证服务机构发现了证书的不当使用，或者证书被用于违法甚至犯罪行为，电子认证服务机构有权直接吊销您的证书。<br /><br />
          12.在发现或怀疑由权威第三方电子认证服务机构提供的认证服务造成订户的网上交易信息的泄漏和/或篡改时，您应在
          3个月内向电子认证服务机构提出争议处理请求并通知有关各方。
        </div>
      </div>
    </div>
    <div class="agree">
      <el-checkbox v-model="agree" class="agree-checkbox">{{
        i18n.page_content_hasAgreed
      }}</el-checkbox>
      <span class="protocol-name"
        >《
        {{
          i18n.page_content_digitalUsageProtocol
        }}
        》</span
      >
    </div>
    <div class="footer">
      <el-button type="primary" @click="onNext" :disabled="!agree">{{
        i18n.page_content_nextConfirmMsg
      }}</el-button>
    </div>
  </div>
</template>

<script>
const i18n = {
  page_content_hasAgreed: '我已同意',
  page_content_digitalUsageProtocol: '数字证书使用协议',
  page_content_nextConfirmMsg: '下一步，确认信息'
};

const funcView = {};

export default {
  translate: { i18n, funcView },
  data() {
    return {
      agree: false
    };
  },
  inject: ['next'],
  methods: {
    onNext() {
      if (this.agree) {
        this.next();
      }
    }
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.indentification-protocol {
  padding: 24px 0 87px 0;

  .protocol-content {
    width: 100%;
    height: 600px;
    overflow-y: auto;
    padding: 40px 37px 37px 43px;
    color: #495057;
    border: 1px solid #ebebeb;
    .title {
      line-height: 22px;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
    }

    .text-content {
      font-size: 12px;

      .sub-title {
        font-weight: bold;
        line-height: 32px;
        margin-bottom: 14px;
        margin-top: 35px;
      }

      .detail {
        line-height: 20px;
      }
    }
  }

  .agree {
    padding: 24px 0;
    line-height: 20px;
    overflow: hidden;

    /deep/ .agree-checkbox {
      float: left;
      .el-checkbox__label {
        font-size: 12px;
      }
    }
    .protocol-name {
      float: left;
      color: #0d9ae0;
      font-size: 12px;
      margin-left: 4px;
    }
  }
}
</style>
